import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SupplementaryEquipmentDetailsComponent } from './component/supplementary-equipment-details.component';
import { FormsModule } from '@angular/forms';
import { ApplicationClientCommonModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';
import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';


@NgModule({
  declarations: [
    SupplementaryEquipmentDetailsComponent
  ],
  imports: [
    CommonModule,

    FormsModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,
    MatFormFieldModule
  ], exports: [
    SupplementaryEquipmentDetailsComponent
  ]
})
export class SupplementaryEquipmentDetailsModule { }
